enum Category {
  WEAR = 'WEAR',
  SUNDRIES = 'SUNDRIES',
  BEAUTY = 'BEAUTY',
  DIGITAL = 'DIGITAL',
  INTERIOR = 'INTERIOR',
  BIRTH = 'BIRTH',
  FOOD = 'FOOD',
  SPORTS = 'SPORTS',
  LIFE = 'LIFE',
  CULTURE = 'CULTURE',
  DUTY = 'DUTY',
}
export default Category
